import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CryptoService {
  private readonly secretKey = 'abraj-secret-key-2024'; // In production, this should come from environment

  /**
   * Encrypts a string using simple Base64 encoding with a key
   * @param text The text to encrypt
   * @returns Encrypted string
   */
  encrypt(text: string): string {
    try {
      // Simple encryption: Base64 encode with key prepending
      const combined = this.secretKey + text;
      return btoa(combined);
    } catch (error) {
      console.error('Encryption error:', error);
      return text; // Fallback to original text
    }
  }

  /**
   * Decrypts a string using simple Base64 decoding with key removal
   * @param encryptedText The encrypted text to decrypt
   * @returns Decrypted string
   */
  decrypt(encryptedText: string): string {
    try {
      // Simple decryption: Base64 decode and remove key
      const decoded = atob(encryptedText);
      if (decoded.startsWith(this.secretKey)) {
        return decoded.substring(this.secretKey.length);
      }
      // If key not found, return as is (might be unencrypted token for backward compatibility)
      return encryptedText;
    } catch (error) {
      console.error('Decryption error:', error);
      return encryptedText; // Fallback to original text
    }
  }

  /**
   * Checks if a string appears to be encrypted
   * @param text The text to check
   * @returns True if appears encrypted, false otherwise
   */
  isEncrypted(text: string): boolean {
    try {
      const decoded = atob(text);
      return decoded.startsWith(this.secretKey);
    } catch {
      return false;
    }
  }
}
